// One tab always open. Tabs register in DOM order for a 1-based index,
// and hand up their image — images[i - 1] belongs to tab i.
window.ProcessGraphic = () => {
	return {
		current: null,
		count: 0,
		ready: false,
		images: [],

		init() {
			this.$nextTick(() => {
				this.lockHeight();
				this.ready = true;
			});

			// Re-measure after webfonts: display=swap changes header wrapping.
			document.fonts?.ready.then(() => this.lockHeight());

			let resizeTimer = null;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(() => this.lockHeight(), 150);
			});
		},

		// Pin the row to its tallest state so the section never resizes.
		// Toggled directly, not via `current`: Alpine applies state async.
		lockHeight() {
			const row = this.$el.querySelector('.process-graphic-innerblocks');
			if (!row) return;

			row.style.minHeight = '';

			// Below xl heights are meant to change.
			if (!window.matchMedia('(min-width: 80rem)').matches) return;

			const cards = Array.from(row.querySelectorAll('.process-graphic-tab'));
			if (cards.length < 2) return;

			const open = cards.map((card) => card.classList.contains('is-open'));
			let tallest = 0;

			row.classList.add('pg-measuring');
			cards.forEach((_, candidate) => {
				cards.forEach((card, i) => card.classList.toggle('is-open', i === candidate));
				tallest = Math.max(tallest, row.offsetHeight);
			});
			cards.forEach((card, i) => card.classList.toggle('is-open', open[i]));
			row.classList.remove('pg-measuring');

			row.style.minHeight = `${tallest}px`;
		},

		register(image = { url: '', alt: '' }) {
			const i = ++this.count;
			this.images.push(image);
			if (this.current === null) this.current = i;
			return i;
		},

		select(i) {
			this.current = i;
		},

		// State classes for a tab at index i (kept here so the quotes live in JS,
		// not in a Twig attribute where editors may "smart-quote" them).
		classes(i) {
			return {
				'is-open': i === this.current,
				'is-opened': i < this.current,
				'is-unopened': i > this.current,
				'is-ready': this.ready,
			};
		},
	};
};
